import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@justhome/react-ui";
import { useQualificationContext } from "@modules/booking/context/context";
import { QualificationStateId } from "@modules/booking/context/machine";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import BookingLeadWall from "../BookingLeadWall";
import CalendarComplete from "../CalendarComplete";
import CalendarStep from "../CalendarStep";
import Disqualified from "../Disqualified";
import EmploymentForm from "../EmploymentForm";
import EquityForm from "../EquityForm";
import IncomeForm from "../IncomeForm";
import ProjectConfirmation from "../ProjectConfirmation";
import PropertyForm from "../PropertyForm";
import ReconfirmationComplete from "../ReconfirmationComplete";
import ReconfirmationForm from "../ReconfirmationForm";
import ResidenceForm from "../ResidenceForm";
import PropertyViewingStatusForm from "../PropertyViewingStatusForm";
interface QualificationFormProps {
  showFirstStepText?: boolean;
}
const QualificationForm = t0 => {
  const $ = _c(32);
  const {
    showFirstStepText
  } = t0;
  const {
    t
  } = useBookingTranslation();
  const {
    stepId,
    goToNextStep,
    handleMeetingScheduled,
    handleReconfirmation,
    firstStepId,
    goToPreviousStep,
    isLoading,
    isError,
    meetingTime,
    handleLeadCreated,
    property,
    contactId,
    partnerId,
    clientMode,
    lead,
    skipQualification
  } = useQualificationContext();
  let t1;
  if ($[0] !== firstStepId || $[1] !== stepId) {
    t1 = typeof stepId === "string" && !stepId.startsWith(firstStepId ?? "");
    $[0] = firstStepId;
    $[1] = stepId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== goToPreviousStep || $[4] !== isError || $[5] !== isLoading || $[6] !== t1) {
    t2 = {
      canGoBack: t1,
      onGoBack: goToPreviousStep,
      isLoading,
      isError
    };
    $[3] = goToPreviousStep;
    $[4] = isError;
    $[5] = isLoading;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const formSectionProps = t2;
  const isFirstStep = stepId === firstStepId;
  let t3;
  if ($[8] !== isFirstStep || $[9] !== showFirstStepText || $[10] !== t) {
    t3 = isFirstStep && showFirstStepText && <div className="w-[600px] max-w-full"><h2 className="text-h2 font-semibold mb-2xs">{t("title")}</h2><p className="text-body-2 text-neutral-675/60 mb-m">{t("description")}</p></div>;
    $[8] = isFirstStep;
    $[9] = showFirstStepText;
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const firstStepText = t3;
  if (stepId === "leadWall") {
    let t4;
    if ($[12] !== clientMode || $[13] !== contactId || $[14] !== handleLeadCreated || $[15] !== partnerId || $[16] !== property) {
      t4 = <BookingLeadWall onLeadCreated={handleLeadCreated} property={property} contactId={contactId} partnerId={partnerId} clientMode={clientMode} />;
      $[12] = clientMode;
      $[13] = contactId;
      $[14] = handleLeadCreated;
      $[15] = partnerId;
      $[16] = property;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    return t4;
  }
  let t4;
  if ($[18] !== formSectionProps || $[19] !== goToNextStep || $[20] !== handleMeetingScheduled || $[21] !== handleReconfirmation || $[22] !== lead || $[23] !== meetingTime || $[24] !== skipQualification) {
    t4 = stepId_0 => {
      switch (stepId_0) {
        case "projectConfirmation":
          {
            return <ProjectConfirmation />;
          }
        case "property":
        case "propertySaving":
          {
            return <PropertyForm onSubmit={goToNextStep} {...formSectionProps} />;
          }
        case "income":
        case "incomeSaving":
          {
            return <IncomeForm onSubmit={goToNextStep} {...formSectionProps} />;
          }
        case "equity":
        case "equitySaving":
          {
            return <EquityForm onSubmit={goToNextStep} {...formSectionProps} />;
          }
        case "residence":
        case "residenceSaving":
          {
            return <ResidenceForm onSubmit={goToNextStep} {...formSectionProps} />;
          }
        case "employment":
        case "employmentSaving":
          {
            return <EmploymentForm onSubmit={goToNextStep} {...formSectionProps} />;
          }
        case "propertyViewingStatus":
        case "propertyViewingStatusSaving":
          {
            return <PropertyViewingStatusForm onSubmit={goToNextStep} {...formSectionProps} />;
          }
        case "disqualified":
          {
            return <Disqualified />;
          }
        case "reconfirmation":
        case "reconfirmationSaving":
          {
            return <ReconfirmationForm onSubmit={handleReconfirmation} {...formSectionProps} />;
          }
        case "reconfirmationComplete":
          {
            return <ReconfirmationComplete />;
          }
        case "calendar":
          {
            return <CalendarStep onMeetingScheduled={handleMeetingScheduled} lead={lead} skipQualification={skipQualification} />;
          }
        case "calendarComplete":
        case "calendarSaving":
          {
            return <CalendarComplete meetingTime={meetingTime} />;
          }
        default:
          {
            return <div className="flex flex-col justify-start w-[600px] max-w-full"><Skeleton className="w-full mb-m" height={38} isLoading={true} /><Skeleton className="mb-2xs" height={36} width={200} isLoading={true} /><Skeleton className="w-full mb-m" height={48} isLoading={true} /><Skeleton className="mb-xs" height={20} width={100} isLoading={true} /><Skeleton className="w-full mb-3s" height={48} isLoading={true} /><Skeleton className="w-full" height={48} isLoading={true} /></div>;
          }
      }
    };
    $[18] = formSectionProps;
    $[19] = goToNextStep;
    $[20] = handleMeetingScheduled;
    $[21] = handleReconfirmation;
    $[22] = lead;
    $[23] = meetingTime;
    $[24] = skipQualification;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  const getRenderedStep = t4;
  let t5;
  if ($[26] !== getRenderedStep || $[27] !== stepId) {
    t5 = getRenderedStep(stepId);
    $[26] = getRenderedStep;
    $[27] = stepId;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  const content = t5;
  let t6;
  if ($[29] !== content || $[30] !== firstStepText) {
    t6 = <>{content && <>{firstStepText}{content}</>}</>;
    $[29] = content;
    $[30] = firstStepText;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
};
export default QualificationForm;